module.exports = __webpack_public_path__ + "c2dae1597b2be4fde88b48c9a888216c.pdf";